module.exports = __webpack_public_path__ + "static/media/recs-hero-line-mobile.7a0f92a4.svg";